<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { NTabs, NTabPane, NAlert, NButton } from 'naive-ui'
import ConfigSection from '../components/sysconfig/ConfigSection.vue'
import ConfigField from '../components/sysconfig/ConfigField.vue'
import NotifiersList from '../components/sysconfig/NotifiersList.vue'
import TokensList from '../components/sysconfig/TokensList.vue'
import GitHubPanel from '../components/sysconfig/GitHubPanel.vue'
import MaintenancePanel from '../components/sysconfig/MaintenancePanel.vue'
import { sysconfig, type ConfigSection as Section } from '../api'
import { createSystemStore } from '../stores/system'

const route = useRoute()
const router = useRouter()
const tab = ref<string>(typeof route.query.tab === 'string' ? route.query.tab : 'runtime')
const store = createSystemStore(sysconfig)
const { error: loadErr } = store

watch(tab, v => { router.replace({ query: { ...route.query, tab: v } }) })

async function reload() {
  try {
    await store.load()
  } catch (e: any) {
    loadErr.value = e.message || String(e)
  }
}

function sectionById(id: string): Section | undefined {
  return store.sectionById(id)
}

onMounted(reload)
</script>

<template>
  <NAlert v-if="loadErr" type="error" show-icon style="margin-bottom:12px">
    {{ loadErr }}
    <NButton size="small" style="margin-left:12px" @click="reload">重试</NButton>
  </NAlert>

  <NTabs v-model:value="tab" type="line" animated>
    <NTabPane name="runtime" tab="运行参数">
      <ConfigSection v-if="sectionById('runtime')" :section="sectionById('runtime')!">
        <ConfigField v-for="f in sectionById('runtime')!.fields" :key="f.key" :field="f" />
      </ConfigSection>
    </NTabPane>

    <NTabPane name="github" tab="GitHub & GHCR">
      <GitHubPanel />
    </NTabPane>

    <NTabPane name="notifiers" tab="通知器">
      <ConfigSection v-if="sectionById('notifiers')" :section="sectionById('notifiers')!">
        <ConfigField v-for="f in sectionById('notifiers')!.fields" :key="f.key" :field="f" />
        <div style="margin-top:16px">
          <NotifiersList />
        </div>
      </ConfigSection>
    </NTabPane>

    <NTabPane name="tokens" tab="Webhook Tokens">
      <ConfigSection v-if="sectionById('tokens')" :section="sectionById('tokens')!">
        <ConfigField v-for="f in sectionById('tokens')!.fields" :key="f.key" :field="f" />
        <div style="margin-top:16px">
          <TokensList />
        </div>
      </ConfigSection>
    </NTabPane>

    <NTabPane name="maintenance" tab="维护 / 自更新">
      <MaintenancePanel />
    </NTabPane>
  </NTabs>
</template>
